var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    opacity: 0.496,
    cx: 24,
    cy: 24,
    r: 23.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h24v24H12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.94 17a2 2 0 1 1-4-.002 2 2 0 0 1 4 .002zm.06 3.48h-4V33h4V20.48zm6.32 0h-3.98V33h3.94v-6.57c0-3.66 4.77-4 4.77 0V33H34v-7.93c0-6.17-7.06-5.94-8.72-2.91l.04-1.68z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIn);
export default __webpack_public_path__ + "static/media/ic-IN.6ca8935e6e5dce197bee84c806597f5d.svg";
export { ForwardRef as ReactComponent };